import { getData } from '../assets/scripts/GeneralFunctions'
import { toast } from 'react-toastify'
import { errorList } from './stateList'
import { addCarSchema } from '../schema/addCarSchema'

export const addCarSubmitHandler = async (
  setIsSubmit,
  inputs,
  setUserResult,
  setError,
  error,
  customer,
  cars,
  setCars
) => {
  setIsSubmit(true)
  try {
    const validatedInputs = await addCarSchema.validate(inputs, { abortEarly: false })

    const queryParams = {
      car_model: validatedInputs.car_model,
      color: validatedInputs.color,
      monthly_ride: validatedInputs.monthly_ride,
      description: null,
      plate_number: {
        first: validatedInputs.first,
        letter: validatedInputs.letter,
        second: validatedInputs.second,
        state: validatedInputs.state,
      },
      aras_plate: validatedInputs.aras_plate,
    }

    const apiResult = await getData(
      `admin/cars/create/${customer?.id}`,
      'post',
      queryParams,
      true,
      true
    )
    if (apiResult?.status === 200) {
      setIsSubmit(false)
      setUserResult(false)
      setCars([apiResult?.data?.car, ...cars])
      toast.success('موفقیت آمیز')
    } else {
      setError(apiResult?.error)
    }
  } catch (err) {
    setError({
      ...error,
      ...errorList(err),
    })
  } finally {
    setIsSubmit(false)
  }
}
